import { useControls } from './useControls';

export function useAdWindow(): Window {
  const { renderSlot } = useControls();

  return renderSlot.ownerDocument.defaultView ?? window;
}
